/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentDetails model module.
 * @module model/StudentDetails
 * @version 1.0.0
 */
class StudentDetails {
    /**
     * Constructs a new <code>StudentDetails</code>.
     * @alias module:model/StudentDetails
     */
    constructor() { 
        
        StudentDetails.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentDetails} obj Optional instance to populate.
     * @return {module:model/StudentDetails} The populated <code>StudentDetails</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentDetails();

            if (data.hasOwnProperty('full_name')) {
                obj['full_name'] = ApiClient.convertToType(data['full_name'], 'String');
            }
            if (data.hasOwnProperty('nif')) {
                obj['nif'] = ApiClient.convertToType(data['nif'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The full name of the student
 * @member {String} full_name
 */
StudentDetails.prototype['full_name'] = undefined;

/**
 * The NIF of the student
 * @member {String} nif
 */
StudentDetails.prototype['nif'] = undefined;






export default StudentDetails;

